import React, { ReactNode } from "react";
import { Button as MUIBtton } from "@mui/material";
import classNames from "classnames";

export type ButtonAppearance =
  | "warning"
  | "error"
  | "success"
  | "info"
  | "default";

export type ButtonCorners = "default" | "rounded" | "circle";
export type ButtonType = "primary" | "secondary" | "text";

interface ButtonProps {
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  disabled?: boolean;
  type?: ButtonType;
  htmlType?: "button" | "submit" | "reset";
  appearance?: ButtonAppearance;
  corners?: ButtonCorners;
  onClick?: () => void | Promise<void>;
}

const Button = (props: ButtonProps) => {
  const {
    children,
    className,
    disabled,
    icon,
    type = "primary",
    appearance,
    corners,
    htmlType = "button",
    onClick,
  } = props;

  const btnClassName = classNames(className, "dui-btn", {
    [`dui-btn-${type}`]: type !== undefined,
    [`dui-btn-${appearance}`]: appearance !== undefined,
    [`dui-btn-${corners}`]: corners !== undefined,
    "dui-btn-icon-only": icon !== undefined && children === undefined,
    "dui-btn-disabled": disabled,
  });

  return (
    <MUIBtton
      className={btnClassName}
      onClick={onClick}
      disabled={disabled}
      type={htmlType}
    >
      <div className="dui-btn-inner">
        {icon !== undefined && <div className="dui-btn-icon">{icon}</div>}
        {children !== undefined && (
          <div className="dui-btn-text">{children}</div>
        )}
      </div>
    </MUIBtton>
  );
};

export default Button;
